import React from "react";

const PurpleShine = ({ type }) => {
  return <div className={`purple-shine ${type}`}></div>;
};

export default PurpleShine;
